import { mapQueryToFitment } from '../../../../../../../shared/utils/fitment/fitment';

import { CUSTOMER_SERVICE_IS_DOWN } from '../../../../../../../shared/constants/errors';

export function getMyAccountVehicleInput(fitment) {
  let rideHeight;

  if (!fitment) return {};

  if (fitment.rideHeight && fitment.rideHeightId && fitment.rideHeightType) {
    rideHeight = {
      description: fitment.rideHeight,
      id: fitment.rideHeightId,
      type: fitment.rideHeightType
    };
  }

  return {
    code: fitment.uid,
    frontTireSize: fitment.frontTireSize,
    frontWheelRimDiameter: fitment.frontWheelDiameter,
    isActive: fitment.isActive,
    isOE: fitment.isOE,
    rearTireSize: fitment.rearTireSize,
    rearWheelRimDiameter: fitment.rearWheelDiameter,
    rideHeight,
    sizeQualifier: fitment.sizeQualifier,
    vehicleAssemblyID: fitment.vehicleAssemblyId
  };
}

export function isCustomerServiceDownErrorPresent(response) {
  return Boolean(
    response?.errors?.some(error =>
      error?.message?.includes(CUSTOMER_SERVICE_IS_DOWN)
    )
  );
}

export function mapAccountQueryVehicle(vehicle) {
  return {
    ...mapQueryToFitment(vehicle),
    frontTireSize: vehicle?.frontTireSize || null,
    frontWheelDiameter: vehicle?.frontWheelRimDiameter || null,
    rearTireSize: vehicle?.rearTireSize || null,
    rearWheelDiameter: vehicle?.rearWheelRimDiameter || null
  };
}
